import openWindow from './openWindow';
import openPdfWin from './openPdfWin';
import { URL_UMS_REDIRECT } from '../config/url-consts';

/** this function is used to open a URL using a UMS UrlMapEntry ID.
 * @param {string} id the UMS UrlMapEntry ID for the URL
 * @param {string} winName The name of the window (to allow for multiple windows).
 * @param {string} parms Parameters for creation of the new window
 * @param {number} width width of window
 * @param {number} height height of window
 * @param {number} left # of pixels from left for window placement
 * @param {number} top # of pixels from top for window placement
 * @param {boolean} pdf flag to determine if the UMS ID is a PDF link
 */
const openUMSWin = (id, winName, parms, width, height, left, top, pdf) => {
  const finalUrl = `${URL_UMS_REDIRECT(window.location.href)}?keyId=${id}`;
  if (pdf === true) {
    openPdfWin(finalUrl, null, width, height);
  } else {
    let winWidth = 0;
    if (typeof width === 'number') {
      winWidth = width < 1 ? Math.floor(window.screen.availWidth * width) : width;
    } else if (window.screen.width > 1900) {
      winWidth = Math.floor(window.screen.availWidth * 0.55);
    } else if (window.screen.width > 1280) {
      winWidth = Math.floor(window.screen.availWidth * 0.7);
    } else {
      winWidth = Math.floor(window.screen.availWidth * 0.8);
    }
    let winHeight = 0;
    if (typeof height === 'number') {
      winHeight = height < 1 ? Math.floor(window.screen.availWidth * height) : height;
    } else {
      const aHeight = window.screen.availHeight;
      winHeight = aHeight < 800 ? Math.floor(aHeight * 0.7) : Math.floor(aHeight * 0.77);
    }
    const winParms = typeof parms === 'string' ? parms : 'directories=yes,location=yes,resizable=yes,status=yes,scrollbars=yes,hotkeys=yes,menubar=yes,toolbar=yes,personalbar=yes,titlebar=yes';
    const winConfig = {
      winURL: finalUrl,
      winNa: winName,
      winParms,
      winWidth,
      winHeight,
      winLeft: left,
      winTop: top
    };
    openWindow(winConfig);
  }
};
export default openUMSWin;
//# sourceMappingURL=openUMSWin.js.map